import React from 'react';

import { Footer, Header } from '$partials/global';
import { ModuleDispatcher } from '$partials/modules';
import { OfficeDetailsColumn } from '$partials/modules/blocks';
import { HygieneSchema } from '$partials/hygiene';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/pages.d.ts').HygienePage}
 */


const HygienePage = (props) => {
    const page = props.data.page;

    // Normalize offices data to match expected format
    const normalizedOffices = page?.hygieneFooterOffices?.length > 0 ? {
        edges: page.hygieneFooterOffices.map((item) => ({
            node: item.office
        }))
    } : null;

    return (
        <>
            <HygieneSchema
                page={page}
                url={props?.location} />

            <Header {...props.data.header} />

            <main id='main-content'>
                <section className='theme-light-alt bg-main-background'>
                    <div className='layout-container layout-site-outer-padding py-24 sm:py-48 md:pt-160 md:pb-48'>
                        <h1 className='text-main-text-primary type-style-1'>
                            {page?.title}
                        </h1>
                    </div>
                </section>

                {page?.modules?.length > 0 && (
                    <section className='theme-light-alt'>
                        {page.modules.map((module, i) => (
                            <ModuleDispatcher
                                {...module}
                                key={i + module?.id}/>
                        ))}
                    </section>
                )}

                {normalizedOffices && (
                    <OfficeDetailsColumn
                        offices={normalizedOffices}
                        officesHeading={page?.officeContactHeader}
                        officesSubheading={page?.officeContactBody}/>
                )}
            </main>
            <Footer {...props.data.footer} />
        </>
    );
};

/* ========================================================================= */
/* Exports */
/* ========================================================================= */

export default HygienePage;
